module.exports = __webpack_public_path__ + "static/media/location.86b0c06c.svg";